import { loginroutes } from "./login/routes";
import { forgotroutes } from "./forgot/routes";
import { resetroutes } from "./reset/routes";
import { pinresetroutes } from "./resetpin/routes";
import { signuproutes } from "./signup/routes";
import { veroutes } from "./verifyemail/routes";
import { varoutes } from "./verifyaccount/routes";
import { susroutes } from "./info/routes";
import SiteIndex from "./index";

import {accesspinroutes} from "./infopluspin/routes";

import Login, { loginaction } from "./login/index";

import { kycroutes } from "../dashboard/Kyc/routes";

import { Outlet, Link, useLoaderData, Form } from "react-router-dom";
import aut from "./auth.module.scss";

import SiteError from "./error";

export const Auth = () => {
 return (
  <>
   <div className={aut.auht}>
    <div className={aut.body}>
     <Outlet />
    </div>
   </div>
  </>
 );
};
export const authroutes = [
 {
  path: "/",
  element: <Auth />,
  errorElement: <SiteError />,
  //loader: rasloader,
  //action: rasaction,
  children: [
   {
    index: true,
    //element: <SiteIndex />,
    element: <Login />,
    action: loginaction,
    //loader: itloader,
   },
  ],
 },
 { ...kycroutes },
 {
  path: "account",
  element: <Auth />,
  errorElement: <SiteError />,
  //loader: rasloader,
  //action: rasaction,
  children: [
   {
    index: true,
    element: <Login />,
    action: loginaction,
    //element: <SiteIndex />,
    //loader: itloader,
   },
   { ...loginroutes },
   { ...varoutes },
   { ...susroutes },
   { ...veroutes },
   {...accesspinroutes},

   { ...signuproutes },
   { ...forgotroutes },
   { ...resetroutes },
   { ...pinresetroutes },
  ],
 },
];

/*
  {index: true,  
      element: <DashboardIndex />,
      //loader: contactLoader,
    },*/
